// Petra Fina: native product size recommender. No customer measurement is sent to third parties.
(function () {
  if (window.__petraNativeSizeRecommender) return;
  window.__petraNativeSizeRecommender = true;

  var STYLE_ID = 'petra-native-size-recommender-style';
  var MODAL_ID = 'petra-native-size-recommender-modal';

  function normalize(value) {
    return String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim();
  }

  function numberFrom(value) {
    var match = String(value || '').replace(',', '.').match(/\d+(?:\.\d+)?/);
    return match ? Number(match[0]) : null;
  }

  function getSizeValues() {
    var nodes = document.querySelectorAll('.product-page-info__options [data-property="tamanho"] div, .product-page-info__options [data-property="Tamanho"] div');
    var sizes = Array.prototype.map.call(nodes, function (node) { return node.textContent.trim(); }).filter(Boolean);
    return sizes.filter(function (value, index) { return sizes.indexOf(value) === index; });
  }

  function findChart() {
    function dimensionFor(value) {
      var label = normalize(value);
      if (label.indexOf('busto') !== -1) return 'bust';
      if (label.indexOf('cintura') !== -1) return 'waist';
      if (label.indexOf('quadril') !== -1) return 'hip';
      return null;
    }

    var tables = Array.prototype.slice.call(document.querySelectorAll('table'));
    for (var tableIndex = 0; tableIndex < tables.length; tableIndex += 1) {
      var table = tables[tableIndex];
      var text = normalize(table.textContent);
      if (!/(busto|cintura|quadril)/.test(text)) continue;

      var rows = Array.prototype.slice.call(table.querySelectorAll('tr'));
      if (rows.length < 2) continue;
      var headers = Array.prototype.map.call(rows[0].querySelectorAll('th, td'), function (cell) { return cell.textContent.trim(); });
      if (headers.length < 2) continue;
      var columnDimensions = headers.map(dimensionFor);
      var chart = { sizes: [], bust: {}, waist: {}, hip: {} };

      // Petra Fina uses the common format: the first row names measurements
      // and each following row represents one size (P, M, G, etc.).
      if (columnDimensions.some(Boolean)) {
        rows.slice(1).forEach(function (row) {
          var cells = Array.prototype.map.call(row.querySelectorAll('th, td'), function (cell) { return cell.textContent.trim(); });
          if (cells.length < 2) return;
          var sizeLabel = cells[0];
          var sizeKey = normalize(sizeLabel);
          if (!sizeKey) return;
          chart.sizes.push(sizeLabel);
          columnDimensions.forEach(function (dimension, index) {
            if (!dimension) return;
            var value = numberFrom(cells[index]);
            if (value !== null) chart[dimension][sizeKey] = value;
          });
        });
        if (Object.keys(chart.bust).length || Object.keys(chart.waist).length || Object.keys(chart.hip).length) return chart;
        continue;
      }

      chart.sizes = headers.slice(1);

      rows.slice(1).forEach(function (row) {
        var cells = Array.prototype.map.call(row.querySelectorAll('th, td'), function (cell) { return cell.textContent.trim(); });
        if (cells.length < 2) return;
        var dimension = dimensionFor(cells[0]);
        if (!dimension) return;
        chart.sizes.forEach(function (size, index) {
          var value = numberFrom(cells[index + 1]);
          if (value !== null) chart[dimension][normalize(size)] = value;
        });
      });
      if (Object.keys(chart.bust).length || Object.keys(chart.waist).length || Object.keys(chart.hip).length) return chart;
    }
    return null;
  }

  function availableChartSizes(chart) {
    var productSizes = getSizeValues().map(normalize);
    return chart.sizes.map(function (size) { return { label: size, key: normalize(size) }; }).filter(function (size) {
      return !productSizes.length || productSizes.indexOf(size.key) !== -1;
    });
  }

  function recommendation(chart, measurements) {
    var candidates = availableChartSizes(chart).map(function (size) {
      var score = 0;
      var points = 0;
      [['bust', measurements.bust], ['waist', measurements.waist], ['hip', measurements.hip]].forEach(function (entry) {
        var target = entry[1];
        var chartValue = chart[entry[0]][size.key];
        if (target && chartValue) {
          score += Math.abs(chartValue - target);
          points += 1;
        }
      });
      return { label: size.label, key: size.key, score: points ? score / points : Infinity, points: points };
    }).filter(function (candidate) { return candidate.points > 0; }).sort(function (a, b) { return a.score - b.score; });
    return candidates[0] || null;
  }

  function selectSize(value) {
    var wanted = normalize(value);
    var nodes = document.querySelectorAll('.product-page-info__options [data-property="tamanho"] div, .product-page-info__options [data-property="Tamanho"] div');
    Array.prototype.some.call(nodes, function (node) {
      if (normalize(node.textContent) !== wanted) return false;
      node.click();
      return true;
    });
  }

  function openTable() {
    var table = Array.prototype.slice.call(document.querySelectorAll('table')).find(function (candidate) {
      return /(busto|cintura|quadril)/.test(normalize(candidate.textContent));
    });
    if (table) table.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  function clamp(value, minimum, maximum) {
    return Math.min(maximum, Math.max(minimum, value));
  }

  function updateFitPreview(modal) {
    var preview = modal.querySelector('.petra-size-recommender__preview');
    if (!preview) return;
    var bust = numberFrom(modal.querySelector('input[name="bust"]').value);
    var waist = numberFrom(modal.querySelector('input[name="waist"]').value);
    var hip = numberFrom(modal.querySelector('input[name="hip"]').value);
    var height = numberFrom(modal.querySelector('input[name="height"]').value);

    // The illustration is deliberately a proportion aid, not a body scan.
    preview.style.setProperty('--petra-fit-bust', clamp(1 + ((bust || 90) - 90) / 180, .82, 1.2));
    preview.style.setProperty('--petra-fit-waist', clamp(1 + ((waist || 72) - 72) / 180, .82, 1.2));
    preview.style.setProperty('--petra-fit-hip', clamp(1 + ((hip || 98) - 98) / 180, .82, 1.2));
    preview.style.setProperty('--petra-fit-height', clamp(1 + ((height || 165) - 165) / 600, .9, 1.12));
  }

  function addStyles() {
    if (document.getElementById(STYLE_ID)) return;
    var style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = [
      '.petra-size-recommender { margin: 14px 0; }',
      '.petra-size-recommender__trigger { display: inline-flex; align-items: center; justify-content: center; width: 100%; min-height: 44px; border: 1px solid #1f1b1d; background: #fff; color: #1f1b1d; font-family: inherit; font-size: 13px; font-weight: 600; line-height: 1.1; letter-spacing: .04em; text-transform: uppercase; cursor: pointer; }',
      '.petra-size-recommender__trigger:hover, .petra-size-recommender__trigger:focus-visible { background: #1f1b1d; color: #fff; outline: 0; }',
      '.petra-size-recommender__modal { position: fixed; inset: 0; z-index: 10002; display: none; align-items: center; justify-content: center; padding: 18px; background: rgba(22, 18, 20, .48); }',
      '.petra-size-recommender__modal.is-open { display: flex; }',
      '.petra-size-recommender__dialog { position: relative; width: min(100%, 650px); max-height: min(720px, calc(100dvh - 36px)); overflow-y: auto; overscroll-behavior: contain; -webkit-overflow-scrolling: touch; padding: 26px; background: #fff; box-shadow: 0 18px 44px rgba(0, 0, 0, .24); font-family: inherit; }',
      '.petra-size-recommender__close { position: absolute; top: 11px; right: 11px; width: 34px; height: 34px; border: 0; background: transparent; color: #1f1b1d; font-family: inherit; font-size: 28px; line-height: 1; cursor: pointer; }',
      '.petra-size-recommender__title { margin: 0 36px 8px 0; color: #1f1b1d; font-family: inherit; font-size: 20px; font-weight: 600; line-height: 1.2; }',
      '.petra-size-recommender__intro { margin: 0 0 18px; color: #5b5356; font-family: inherit; font-size: 14px; line-height: 1.45; }',
      '.petra-size-recommender__experience { display: grid; grid-template-columns: minmax(180px, 210px) minmax(0, 1fr); gap: 22px; align-items: start; }',
      '.petra-size-recommender__preview { --petra-fit-bust: 1; --petra-fit-waist: 1; --petra-fit-hip: 1; --petra-fit-height: 1; display: grid; justify-items: center; gap: 8px; padding: 14px 10px 12px; border: 1px solid #e5dedb; background: #fbf8f6; }',
      '.petra-size-recommender__figure { width: 150px; height: 282px; overflow: visible; }',
      '.petra-size-recommender__figure .petra-fit-body { fill: #e7e4e2; }',
      '.petra-size-recommender__figure .petra-fit-dress { fill: #fff; stroke: #51494c; stroke-width: 1.25; transition: transform .22s ease; }',
      '.petra-size-recommender__figure .petra-fit-bodice { transform-box: fill-box; transform-origin: center bottom; transform: scaleX(var(--petra-fit-bust)); }',
      '.petra-size-recommender__figure .petra-fit-waist { transform-box: fill-box; transform-origin: center; transform: scaleX(var(--petra-fit-waist)); }',
      '.petra-size-recommender__figure .petra-fit-skirt { transform-box: fill-box; transform-origin: center top; transform: scaleX(var(--petra-fit-hip)) scaleY(var(--petra-fit-height)); }',
      '.petra-size-recommender__preview-caption { margin: 0; color: #655d60; font-family: inherit; font-size: 11px; line-height: 1.35; text-align: center; }',
      '.petra-size-recommender__controls { min-width: 0; }',
      '.petra-size-recommender__grid { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 12px; }',
      '.petra-size-recommender__field { display: grid; gap: 6px; color: #302b2d; font-family: inherit; font-size: 12px; font-weight: 600; line-height: 1.2; text-transform: uppercase; letter-spacing: .04em; }',
      '.petra-size-recommender__field input { width: 100%; min-height: 42px; box-sizing: border-box; border: 1px solid #cfc7c4; padding: 8px 10px; color: #1f1b1d; font-family: inherit; font-size: 16px; line-height: 1; }',
      '.petra-size-recommender__helper { grid-column: 1 / -1; margin: -2px 0 2px; color: #6b6365; font-family: inherit; font-size: 12px; line-height: 1.4; }',
      '.petra-size-recommender__submit, .petra-size-recommender__select { width: 100%; min-height: 46px; margin-top: 16px; border: 1px solid #1f1b1d; background: #1f1b1d; color: #fff; font-family: inherit; font-size: 13px; font-weight: 600; line-height: 1.1; letter-spacing: .05em; text-transform: uppercase; cursor: pointer; }',
      '.petra-size-recommender__result { display: none; margin-top: 18px; padding: 14px; border: 1px solid #e5dedb; background: #fbf8f6; color: #312b2d; font-family: inherit; font-size: 14px; line-height: 1.45; }',
      '.petra-size-recommender__result.is-visible { display: block; }',
      '.petra-size-recommender__result strong { display: block; margin-bottom: 5px; font-size: 16px; }',
      '.petra-size-recommender__table { display: block; width: 100%; margin-top: 12px; border: 0; background: transparent; color: #312b2d; font-family: inherit; font-size: 13px; font-weight: 600; line-height: 1.2; text-decoration: underline; text-underline-offset: 3px; cursor: pointer; }',
      '@media (max-width: 767px) { .petra-size-recommender { margin: 12px 0; } .petra-size-recommender__modal { align-items: flex-start; padding: 8px; overflow-y: auto; } .petra-size-recommender__dialog { width: 100%; max-height: none; min-height: min-content; margin: auto 0; padding: 20px 16px; } .petra-size-recommender__experience { grid-template-columns: 1fr; gap: 16px; } .petra-size-recommender__preview { grid-template-columns: auto minmax(0, 1fr); align-items: center; text-align: left; padding: 10px; } .petra-size-recommender__figure { width: 94px; height: 164px; } .petra-size-recommender__preview-caption { text-align: left; } }',
      '@media (max-width: 359px) { .petra-size-recommender__grid { grid-template-columns: 1fr; } .petra-size-recommender__dialog { padding-left: 14px; padding-right: 14px; } }'
    ].join('\n');
    document.head.appendChild(style);
  }

  function createModal() {
    var modal = document.createElement('div');
    modal.id = MODAL_ID;
    modal.className = 'petra-size-recommender__modal';
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.setAttribute('aria-labelledby', 'petra-size-recommender-title');
    modal.innerHTML = [
      '<div class="petra-size-recommender__dialog">',
      '<button class="petra-size-recommender__close" type="button" aria-label="Fechar">&times;</button>',
      '<h2 class="petra-size-recommender__title" id="petra-size-recommender-title">Encontre seu tamanho</h2>',
      '<p class="petra-size-recommender__intro">Informe suas medidas em cm. A sugestão usa a tabela deste produto.</p>',
      '<div class="petra-size-recommender__experience">',
      '<div class="petra-size-recommender__preview" role="img" aria-label="Simulação visual de proporção do vestido">',
      '<svg class="petra-size-recommender__figure" viewBox="0 0 160 300" aria-hidden="true">',
      '<circle class="petra-fit-body" cx="80" cy="30" r="17"></circle>',
      '<path class="petra-fit-body" d="M58 53 L102 53 L112 111 L100 169 L60 169 L48 111 Z"></path>',
      '<path class="petra-fit-body" d="M57 62 L35 137 L43 140 L66 82 Z M103 62 L125 137 L117 140 L94 82 Z"></path>',
      '<path class="petra-fit-dress petra-fit-bodice" d="M57 72 L103 72 L101 139 L59 139 Z"></path>',
      '<path class="petra-fit-dress petra-fit-waist" d="M58 132 L102 132 L103 145 L57 145 Z"></path>',
      '<path class="petra-fit-dress petra-fit-skirt" d="M57 144 L103 144 L130 253 L30 253 Z"></path>',
      '<path class="petra-fit-body" d="M65 253 L76 253 L73 292 L62 292 Z M84 253 L95 253 L98 292 L87 292 Z"></path>',
      '</svg>',
      '<p class="petra-size-recommender__preview-caption">Simulação de proporção. O caimento final depende do modelo e do tecido.</p>',
      '</div>',
      '<div class="petra-size-recommender__controls">',
      '<form class="petra-size-recommender__form">',
      '<div class="petra-size-recommender__grid">',
      '<label class="petra-size-recommender__field">Busto<input name="bust" inputmode="decimal" autocomplete="off" placeholder="Ex.: 90" required></label>',
      '<label class="petra-size-recommender__field">Cintura<input name="waist" inputmode="decimal" autocomplete="off" placeholder="Ex.: 74" required></label>',
      '<label class="petra-size-recommender__field">Quadril<input name="hip" inputmode="decimal" autocomplete="off" placeholder="Opcional"></label>',
      '<label class="petra-size-recommender__field">Altura<input name="height" inputmode="decimal" autocomplete="off" placeholder="Opcional"></label>',
      '<p class="petra-size-recommender__helper">Se estiver entre dois tamanhos, confira a tabela antes de comprar.</p>',
      '</div>',
      '<button class="petra-size-recommender__submit" type="submit">Ver sugestão</button>',
      '</form>',
      '<div class="petra-size-recommender__result" aria-live="polite"></div>',
      '<button class="petra-size-recommender__table" type="button">Ver tabela de medidas</button>',
      '</div>',
      '</div>',
      '</div>'
    ].join('');

    var close = function () { modal.classList.remove('is-open'); };
    modal.querySelector('.petra-size-recommender__close').addEventListener('click', close);
    modal.addEventListener('click', function (event) { if (event.target === modal) close(); });
    modal.querySelector('.petra-size-recommender__table').addEventListener('click', function () { close(); openTable(); });
    modal.querySelectorAll('input[name="bust"], input[name="waist"], input[name="hip"], input[name="height"]').forEach(function (field) {
      field.addEventListener('input', function () { updateFitPreview(modal); });
    });
    updateFitPreview(modal);
    modal.querySelector('.petra-size-recommender__form').addEventListener('submit', function (event) {
      event.preventDefault();
      var fields = new FormData(event.currentTarget);
      var measurements = { bust: numberFrom(fields.get('bust')), waist: numberFrom(fields.get('waist')), hip: numberFrom(fields.get('hip')) };
      var result = modal.querySelector('.petra-size-recommender__result');
      var chart = findChart();
      var size = chart && recommendation(chart, measurements);
      result.classList.add('is-visible');
      if (!size) {
        result.innerHTML = '<strong>Confira a tabela de medidas</strong>Não foi possível criar uma sugestão segura para este produto.';
        return;
      }
      var confidence = size.score <= 4 ? 'boa' : size.score <= 8 ? 'aproximada' : 'limitada';
      result.innerHTML = '<strong>Sugerimos o tamanho ' + size.label + '</strong>Sugestão ' + confidence + ' com base nas medidas informadas. Confira a tabela antes de finalizar.<button class="petra-size-recommender__select" type="button">Selecionar ' + size.label + '</button>';
      result.querySelector('.petra-size-recommender__select').addEventListener('click', function () { selectSize(size.label); close(); });
    });
    document.body.appendChild(modal);
    return modal;
  }

  function removeSizebay() {
    document.querySelectorAll('script[src*="sizebay"], link[href*="sizebay"], #szb-vfr__base, #szb-vfr__module, .vfr__container').forEach(function (node) { node.remove(); });
  }

  function init() {
    if (!document.body || !document.body.classList.contains('template-product')) return;
    removeSizebay();
    addStyles();
    if (document.querySelector('.petra-size-recommender')) return;
    var anchor = document.querySelector('div.product-page-info div.product-options');
    if (!anchor || !anchor.parentNode) return;
    var wrap = document.createElement('div');
    wrap.className = 'petra-size-recommender';
    var trigger = document.createElement('button');
    trigger.type = 'button';
    trigger.className = 'petra-size-recommender__trigger';
    trigger.textContent = 'Encontre seu tamanho';
    trigger.addEventListener('click', function () {
      var modal = document.getElementById(MODAL_ID) || createModal();
      modal.classList.add('is-open');
      modal.querySelector('input[name="bust"]').focus();
    });
    wrap.appendChild(trigger);
    anchor.parentNode.insertBefore(wrap, anchor.nextSibling);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  window.setTimeout(init, 1200);
})();
